import { render, staticRenderFns } from "./MenteeRegistration.vue?vue&type=template&id=722a09fa&"
import script from "./MenteeRegistration.vue?vue&type=script&lang=js&"
export * from "./MenteeRegistration.vue?vue&type=script&lang=js&"
import style0 from "./MenteeRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports